// extracted by mini-css-extract-plugin
module.exports = {"card":"IndustryBrands-module__card___2nnXk","table":"IndustryBrands-module__table___1fr4S"};